/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { MiddlewareSteps } from '../../../core';
import {
    buildRequestInitMiddleware,
    handleHttpDownloadResponseMiddleware,
    handleHttpErrorMiddleware,
    handleInternalErrorMiddleware,
    handleTooManyRequestsErrorMiddleware,
    handleUnauthorizedErrorMiddleware,
    processBodyMiddleware,
    processHeadersMiddleware,
    processUrlMiddleware,
    sendFetchRequestMiddleware,
} from '../middlewares';

export const pluginWebServerDownloadStrategyFlow = {
    [MiddlewareSteps.Prepare]: [
        processUrlMiddleware,
        processHeadersMiddleware,
        processBodyMiddleware,
        buildRequestInitMiddleware,
    ],
    [MiddlewareSteps.Run]: [
        sendFetchRequestMiddleware,
    ],
    [MiddlewareSteps.HandleResponse]: [
        handleHttpDownloadResponseMiddleware,
    ],
    [MiddlewareSteps.HandleErrors]: [
        handleInternalErrorMiddleware,
        handleUnauthorizedErrorMiddleware,
        handleTooManyRequestsErrorMiddleware,
        handleHttpErrorMiddleware,
    ],
};

export const pluginWebServerDownloadStrategyConfig = {
};
